var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33341 17.7702C1.87508 17.7702 1.48258 17.6068 1.15591 17.2802C0.829804 16.9541 0.666748 16.5618 0.666748 16.1035V4.43685C0.666748 3.97852 0.829804 3.58602 1.15591 3.25935C1.48258 2.93324 1.87508 2.77018 2.33341 2.77018H9.77092L8.10425 4.43685H2.33341V16.1035H14.0001V10.3118L15.6667 8.64518V16.1035C15.6667 16.5618 15.5037 16.9541 15.1776 17.2802C14.8509 17.6068 14.4584 17.7702 14.0001 17.7702H2.33341ZM11.6459 3.24935L12.8334 4.41602L7.33342 9.91601V11.1035H8.50008L14.0209 5.58268L15.2084 6.74935L9.20842 12.7702H5.66675V9.22851L11.6459 3.24935ZM15.2084 6.74935L11.6459 3.24935L13.7292 1.16602C14.0626 0.832682 14.462 0.666016 14.9276 0.666016C15.3926 0.666016 15.7848 0.832682 16.1042 1.16602L17.2709 2.35352C17.5904 2.67296 17.7501 3.06185 17.7501 3.52018C17.7501 3.97852 17.5904 4.3674 17.2709 4.68685L15.2084 6.74935Z",
    fill: "#3FA8E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.689d98f4f5e4afa846015fc3f56b7a57.svg";
export { ForwardRef as ReactComponent };